import React from 'react';
import { connect } from 'react-redux';
import AssignmentsInfoPres from '../../presentational/AssignmentsDetail/AssignmentsInfoPres';
import { transformFormValues } from 'src/helpers';
import { updateAssignmentDetailsApi, fetchAssignmentDetailApi } from 'src/services/assignments.service';
import { withSnackbar } from 'notistack';

class AssignmentsInfoContainer extends React.Component {
  state = {
    isEditable: false,
    showCancelEditlModal: false,
    showDeleteModal: false,
    dynamicContent: {},
    isLoading: false,
    formData: {},
  };

  render() {
    return (
      <AssignmentsInfoPres
        assignmentId={this.props.match.params.assignmentId}
        isLoading={this.state.isLoading}
        onFormChange={this.handleFormChange}
        showCancelEditlModal={this.state.showCancelEditlModal}
        dynamicContent={this.state.dynamicContent}
        onEdit={this.handleEdit}
        onCancel={this.toggleEditModal.bind(null, true)}
        onCancelModal={this.handleCancel}
        onConfirmModal={this.toggleModal.bind(null, false)}
        onSave={this.handleSave}
        isEditable={this.state.isEditable}
        formData={this.state.formData}
      />
    );
  }

  componentDidMount = () => {
    const { assignmentId } = this.props.match.params;

    this.setState({
      isLoading: true,
    });
    fetchAssignmentDetailApi(assignmentId).then(
      results => {
        if (results && !results.error && !results.errors) {
          this.setState({
            dynamicContent: results,
          });
        } else {
          let errorMsg = ' - ';
          if (results.error) {
            errorMsg += results.error.message;
          } else if (results.errors) {
            results.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.enqueueSnackbar('Failed to fetch details' + errorMsg, { variant: 'error' });
        }
        this.setState({
          isLoading: false,
        });
      },
      error => {
        this.props.enqueueSnackbar('Failed to fetch details - ' + error.message, { variant: 'error' });
        this.setState({
          isLoading: false,
        });
      },
    );
  };

  handleFormChange = data => {
    this.setState({
      formData: data,
    });
  };

  handleSave = async () => {
    const { formValues } = this.state.formData;
    const { assignmentId } = this.props.match.params;

    const data = {
      entityId: assignmentId,
      ...transformFormValues(formValues),
    };

    this.setState({
      isLoading: true,
    });
    updateAssignmentDetailsApi(data).then(
      results => {
        if (results && !results.error && !results.errors) {
          this.setState({
            dynamicContent: results,
          });
        } else {
          let errorMsg = ' - ';
          if (results.error) {
            errorMsg += results.error.message;
          } else if (results.errors) {
            results.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.enqueueSnackbar('Failed to fetch details' + errorMsg, { variant: 'error' });
        }
        this.setState({
          isLoading: false,
          isEditable: false,
        });
      },
      error => {
        this.props.enqueueSnackbar('Failed to fetch details - ' + error.message, { variant: 'error' });
        this.setState({
          isLoading: false,
          isEditable: false,
        });
      },
    );
  };

  handleEdit = () => {
    this.setState({ isEditable: true });
  };

  toggleModal = status => {
    this.setState({
      showCancelEditlModal: status,
      showDeleteModal: status,
    });
  };

  toggleEditModal = status => {
    this.setState({
      showCancelEditlModal: status,
    });
  };

  handleCancel = () => {
    this.setState({
      showCancelEditlModal: false,
      showDeleteModal: false,
      isEditable: false,
    });
  };
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(AssignmentsInfoContainer));
